import { FC, Fragment } from 'react';
import { Container } from '@optimus-web/core';
import { Section } from './Section/Section';
import { SectionDivider } from './Section/SectionDivider';
import { SectionType } from './types';

export interface SectionListProps {
    sections: Array<SectionType>;
}

export const SectionList: FC<SectionListProps> = ({ sections }) => (
    <Container>
        {sections.map((section, index) => {
            const isLast = index === sections.length - 1;

            return (
                <Fragment key={section.id}>
                    <Section section={section} />
                    {!isLast && <SectionDivider dividerType={section.dividerType} />}
                </Fragment>
            );
        })}
    </Container>
);
